/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { GenericIdDTO } from "./GenericIdDTO";
import { GenericIdDTOFromJSON, GenericIdDTOFromJSONTyped, GenericIdDTOToJSON } from "./GenericIdDTO";
import type { PlatformRefDTO } from "./PlatformRefDTO";
import { PlatformRefDTOFromJSON, PlatformRefDTOFromJSONTyped, PlatformRefDTOToJSON } from "./PlatformRefDTO";

/**
 *
 * @export
 * @interface PatchManyExternalDealFiltersDTO
 */
export interface PatchManyExternalDealFiltersDTO {
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof PatchManyExternalDealFiltersDTO
   */
  filterIds: Array<GenericIdDTO>;
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof PatchManyExternalDealFiltersDTO
   */
  merchants?: Array<GenericIdDTO>;
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof PatchManyExternalDealFiltersDTO
   */
  categories?: Array<GenericIdDTO>;
  /**
   *
   * @type {PlatformRefDTO}
   * @memberof PatchManyExternalDealFiltersDTO
   */
  platform: PlatformRefDTO;
}

/**
 * Check if a given object implements the PatchManyExternalDealFiltersDTO interface.
 */
export function instanceOfPatchManyExternalDealFiltersDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "filterIds" in value;
  isInstance = isInstance && "platform" in value;

  return isInstance;
}

export function PatchManyExternalDealFiltersDTOFromJSON(json: any): PatchManyExternalDealFiltersDTO {
  return PatchManyExternalDealFiltersDTOFromJSONTyped(json, false);
}

export function PatchManyExternalDealFiltersDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchManyExternalDealFiltersDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    filterIds: (json["filterIds"] as Array<any>).map(GenericIdDTOFromJSON),
    merchants: !exists(json, "merchants") ? undefined : (json["merchants"] as Array<any>).map(GenericIdDTOFromJSON),
    categories: !exists(json, "categories") ? undefined : (json["categories"] as Array<any>).map(GenericIdDTOFromJSON),
    platform: PlatformRefDTOFromJSON(json["platform"])
  };
}

export function PatchManyExternalDealFiltersDTOToJSON(value?: PatchManyExternalDealFiltersDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    filterIds: (value.filterIds as Array<any>).map(GenericIdDTOToJSON),
    merchants: value.merchants === undefined ? undefined : (value.merchants as Array<any>).map(GenericIdDTOToJSON),
    categories: value.categories === undefined ? undefined : (value.categories as Array<any>).map(GenericIdDTOToJSON),
    platform: PlatformRefDTOToJSON(value.platform)
  };
}
